import { render } from "./MedMenu.vue?vue&type=template&id=a778e2ea&scoped=true"
import script from "./MedMenu.vue?vue&type=script&lang=js"
export * from "./MedMenu.vue?vue&type=script&lang=js"

import "./MedMenu.vue?vue&type=style&index=0&id=a778e2ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a778e2ea"]])

export default __exports__